import React from 'react';
import { useOktaAuth } from '@okta/okta-react';

const Home = () => {
  const { authState } = useOktaAuth();

  if (!authState?.isAuthenticated) return null;

  const userInfo = authState.idToken?.claims;
  return (
    <div>
      <h1>Welcome {userInfo?.name}!</h1>
      <p>Your email: {userInfo?.email}</p>
      <p>Groups: {userInfo?.groups?.join(', ') || 'none'}</p>
    </div>
  );
};

export default Home;
